import React from 'react';
import { Alert } from '@/components/ui';
import { Vehicle } from '../../../types/Vehicle';

interface VehicleTripInspectionHistorySectionProps {
  vehicle: Vehicle;
}

const VehicleTripInspectionHistorySection: React.FC<VehicleTripInspectionHistorySectionProps> = ({ vehicle }) => {
  return (
    <div>
      <h2>Trip Inspection History</h2>
      <Alert variant="info">
        <i className="bi bi-info-circle tw-mr-2"></i>
        This feature is not yet developed.
      </Alert>
    </div>
  );
};

export default VehicleTripInspectionHistorySection;

